import { GetterTree, Store } from "vuex";
import { ProfileState } from "./types";
import { IRootState } from "../types";
import { buildGetter } from "@dcc/store/utils";
import { Gender } from "@dcc/types/gender";

const getterNames = {
  AGE: "age",
  GENDER: "gender",
  POSTCODE: "postcode"
};

export const getters: GetterTree<ProfileState, IRootState> = {
  [getterNames.AGE](state: ProfileState): number | undefined {
    return state.age;
  },

  [getterNames.GENDER](state: ProfileState): Gender | undefined {
    return state.gender;
  },

  [getterNames.POSTCODE](state: ProfileState): string {
    return state.postcode;
  }
};

export const findGetters = (store: Store<IRootState>) => {
  return {
    getAge: () =>
      buildGetter<number | undefined>(store, "profile", getterNames.AGE),
    getGender: () =>
      buildGetter<Gender | undefined>(store, "profile", getterNames.GENDER),
    getPostcode: () =>
      buildGetter<string>(store, "profile", getterNames.POSTCODE)
  };
};
